// Custom variant-dropdown för höjd/storlek på produktsidan.
//
// Servern renderar både WC:s vanliga <select> och en custom dropdown
// (se lw_single_product_variation_dropdown.php). Den här filen:
//   1. Döljer den native selecten och visar custom-dropdownen (progressiv förbättring).
//   2. Öppnar/stänger listan (state via aria-expanded → CSS sköter visning + chevron).
//   3. Speglar klick tillbaka till <select> via jQuery .change() så WC:s
//      variations_form reagerar (pris, galleri, pristrappor uppdateras som vanligt).
//   4. Uppdaterar knappen när valet ändras — även när WC själv sätter default
//      eller nollställer (reset_variations).
//
// jQuery används medvetet för select-eventet: WC triggar 'change' via jQuery, och
// native addEventListener fångar inte jQuery-triggade events tillförlitligt.
;(function () {
    function initDropdown(wrapper) {
        var toggle  = wrapper.querySelector('[data-lw-vardrop-toggle]')
        var panel   = wrapper.querySelector('[data-lw-vardrop-panel]')
        var labelEl = wrapper.querySelector('[data-lw-vardrop-label]')
        var metaEl  = wrapper.querySelector('[data-lw-vardrop-meta]')
        if (!toggle || !panel || !labelEl || !metaEl) return

        var cell = wrapper.closest('.value') || wrapper.parentElement
        var select = cell ? cell.querySelector('select') : null
        if (!select) return

        var placeholder = wrapper.getAttribute('data-placeholder') || labelEl.textContent
        var options = Array.prototype.slice.call(panel.querySelectorAll('[data-lw-vardrop-option]'))

        // Byt fältetikett ("Storlek" → "Välj storlek") och placera rea-summeringen
        // ("Rea på X av Y storlekar") inline bredvid den. WC:s label ligger i en
        // egen tabellcell (core-template), därför sköts det här i JS.
        var row = wrapper.closest('tr')
        var fieldLabelEl = row ? row.querySelector('label') : null
        if (fieldLabelEl) {
            var fieldLabel = wrapper.getAttribute('data-field-label')
            var saleSummary = wrapper.getAttribute('data-sale-summary')
            if (fieldLabel) fieldLabelEl.textContent = fieldLabel
            if (saleSummary) fieldLabelEl.insertAdjacentHTML('beforeend', saleSummary)
        }

        // Aktivera custom-UI, dölj native select.
        select.classList.add('lw-vardrop-native-hidden')
        wrapper.classList.add('is-active')

        function isOpen() { return toggle.getAttribute('aria-expanded') === 'true' }
        function open() { toggle.setAttribute('aria-expanded', 'true') }
        function close() { toggle.setAttribute('aria-expanded', 'false') }

        function setSelectValue(value) {
            if (window.jQuery) {
                window.jQuery(select).val(value).trigger('change')
            } else {
                select.value = value
                select.dispatchEvent(new Event('change', { bubbles: true }))
            }
        }

        // Speglar aktuellt select-värde till knappen + markerar aktiv rad.
        function reflect(value) {
            var matched = null
            options.forEach(function (opt) {
                var isSel = value !== '' && opt.getAttribute('data-value') === value
                opt.setAttribute('aria-selected', isSel ? 'true' : 'false')
                if (isSel) matched = opt
            })
            if (matched) {
                labelEl.textContent = matched.getAttribute('data-label') || ''
                metaEl.innerHTML = matched.getAttribute('data-toggle-meta') || ''
            } else {
                labelEl.textContent = placeholder
                metaEl.innerHTML = ''
            }
        }

        toggle.addEventListener('click', function (e) {
            e.preventDefault()
            if (isOpen()) close()
            else open()
        })

        options.forEach(function (opt) {
            opt.addEventListener('click', function (e) {
                e.preventDefault()
                setSelectValue(opt.getAttribute('data-value'))
                reflect(opt.getAttribute('data-value'))
                close()
                toggle.focus()
            })
        })

        // Utanförklick + Escape stänger.
        document.addEventListener('click', function (e) {
            if (isOpen() && !wrapper.contains(e.target)) close()
        })
        wrapper.addEventListener('keydown', function (e) {
            if (e.key === 'Escape' && isOpen()) {
                close()
                toggle.focus()
            }
        })

        // Synka när valet ändras (default vid laddning, reset_variations, m.m.).
        function onChange() { reflect(select.value) }
        if (window.jQuery) window.jQuery(select).on('change', onChange)
        else select.addEventListener('change', onChange)

        reflect(select.value)
    }

    function init() {
        document.querySelectorAll('[data-lw-vardrop]').forEach(initDropdown)
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init)
    } else {
        init()
    }
})()
